(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-menu.js') >= 0) return;  svs.modules.push('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-menu.js');
"use strict";

const {
  ItemsMenu,
  LinkItem
} = svs.ui.ReactItemsMenu;
const {
  menuItemsQs,
  queryParam
} = svs.components.tipsen.gameGuideTipsen.constants;
const {
  getDisplayName
} = svs.components.lbUtils.sportProducts;
const {
  useDefinition
} = svs.components.tipsen.engine.utils;
const {
  useHistory
} = ReactRouterDOM;
const {
  TipsenLink
} = svs.components.tipsen.tipsen_link;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  getProductBrandByDraw
} = svs.components.lbUtils.brandMapping.fn;
const lotteryProducts = ['Stryktipset', 'Europatipset', 'Powerplay', 'Topptipset', 'Fullträff'];
const systemProducts = ['Stryktipset', 'Europatipset', 'Powerplay', 'Topptipset', 'Bomben'];
const TipsenMenuLink = _ref => {
  let {
    label,
    queryString
  } = _ref;
  const history = useHistory();
  const qs = new URLSearchParams(history.location.search);
  const currentQs = new URLSearchParams(history.location.search);
  qs.set(queryParam, queryString);
  return React.createElement(LinkItem, {
    Component: TipsenLink,
    label: label,
    selected: currentQs.get(queryParam) === queryString || !currentQs.get(queryParam) && queryString === menuItemsQs.play,
    to: "/spelguide?".concat(qs.toString())
  });
};
const TipsenMenu = _ref2 => {
  var _useDefinition$drawPr, _useDefinition;
  let {
    hasArticleIdSystem,
    hasArticleIdLottery
  } = _ref2;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const classNames = "items-menu-wrapper-side-nav ".concat(branding);
  const productId = (_useDefinition$drawPr = (_useDefinition = useDefinition()) === null || _useDefinition === void 0 || (_useDefinition = _useDefinition.drawProductIds) === null || _useDefinition === void 0 ? void 0 : _useDefinition[0]) !== null && _useDefinition$drawPr !== void 0 ? _useDefinition$drawPr : undefined;
  const productName = getDisplayName(productId);
  const shouldShowLottery = lotteryProducts.includes(productName) && hasArticleIdLottery;
  const shouldShowSystem = systemProducts.includes(productName) && hasArticleIdSystem;
  return React.createElement(ItemsMenu, {
    ariaLabel: "Information om ".concat(productName),
    className: classNames,
    hiddenScrollbar: true
  }, React.createElement(TipsenMenuLink, {
    label: "S\xE5 spelar du",
    queryString: menuItemsQs.play
  }), React.createElement(TipsenMenuLink, {
    label: "Om ".concat(productName),
    queryString: menuItemsQs.about
  }), shouldShowSystem && React.createElement(TipsenMenuLink, {
    label: productName === 'Bomben' ? 'Systemreducering' : 'Systemspel',
    queryString: menuItemsQs.system
  }), shouldShowLottery && React.createElement(TipsenMenuLink, {
    label: "Lottning",
    queryString: menuItemsQs.lottery
  }));
};
setGlobal('svs.components.tipsen.gameGuideTipsen.TipsenMenu', TipsenMenu);

 })(window);